import settings from '@/settings'

let estornar = (id, headers) => {
    return fetch(`${settings.apetrusApi}/cartoes/estorno/?id=${id}`, {
        method: 'post',
        mode: 'cors',
        headers: headers
    })
}

let cancelarEstorno = (id, headers) => {
    return fetch(`${settings.apetrusApi}/cartoes/cancelarestorno/${id}/`, {
        method: 'PUT',
        mode: 'cors',
        headers: headers
    })
}

let comprasParaEstornar = (headers) => {
    return fetch(`${settings.apetrusApi}/cartoes/comprasparaestornar/`, {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    })
}

export default {
    estornar,
    cancelarEstorno,
    comprasParaEstornar
}
